import React from 'react'
import { Currencies } from '@orbital/games-frontend-library'
import { ReactComponent as FoldSVG } from '../../../../lib/assets/icons/fold.svg'
import { ReactComponent as CheckSVG } from '../../../../lib/assets/icons/check.svg'
import { ReactComponent as BetSVG } from '../../../../lib/assets/icons/bet.svg'

export const ButtonsContent = (
  stake: string,
  currency: string,
  toFix: number,
) => {
  const UNDO_TEXT = [
    {
      name: 'Undo',
      content: <span>Undo</span>,
    },
    {
      name: 'Fold',
      content: (
        <>
          <FoldSVG />
          <span>Fold</span>
        </>
      ),
    },
    {
      name: 'Check',
      content: (
        <>
          <CheckSVG />
          <span>Check</span>
        </>
      ),
    },
    {
      name: 'NewBet',
      content: <span>New Bets</span>,
    },
  ]

  const DEAL_TEXT = [
    {
      name: 'Deal',
      content: (
        <>
          <span className='deal-rebet'>DEAL</span>
          <span>{Currencies[currency]}</span>
          <span>{stake}</span>
        </>
      ),
    },
    {
      name: 'Raise',
      content: (
        <>
          <FoldSVG />
          <span>Raise</span>
        </>
      ),
    },
    {
      name: 'Bet',
      content: (
        <>
          <BetSVG />
          <span>Bet</span>
        </>
      ),
    },
    {
      name: 'Rebet',
      content: (
        <>
          <span className='deal-rebet'>REBET</span>
          <span>{Currencies[currency]}</span>
          <span>{Number(stake).toFixed(toFix)}</span>
        </>
      ),
      // content: `REBET  ${Currencies[currency]}${Number(stake).toFixed(toFix)}`,
    },
  ]

  return { UNDO_TEXT, DEAL_TEXT }
}
